import revive_payload_client_4sVQNw7RlN from "/builds/masterbranch1/smg-lsi/smg-lsi-admin/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/builds/masterbranch1/smg-lsi/smg-lsi-admin/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/builds/masterbranch1/smg-lsi/smg-lsi-admin/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/builds/masterbranch1/smg-lsi/smg-lsi-admin/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/builds/masterbranch1/smg-lsi/smg-lsi-admin/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/builds/masterbranch1/smg-lsi/smg-lsi-admin/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/builds/masterbranch1/smg-lsi/smg-lsi-admin/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_A0OWXRrUgq from "/builds/masterbranch1/smg-lsi/smg-lsi-admin/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/builds/masterbranch1/smg-lsi/smg-lsi-admin/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/builds/masterbranch1/smg-lsi/smg-lsi-admin/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_w2VlvAEcpa from "/builds/masterbranch1/smg-lsi/smg-lsi-admin/node_modules/nuxt-bugsnag/dist/runtime/client/plugin.mjs";
import filters_client_leW4wqvSMQ from "/builds/masterbranch1/smg-lsi/smg-lsi-admin/plugins/filters.client.js";
import quill_editor_client_4SCKY6swlq from "/builds/masterbranch1/smg-lsi/smg-lsi-admin/plugins/quill-editor.client.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_w2VlvAEcpa,
  filters_client_leW4wqvSMQ,
  quill_editor_client_4SCKY6swlq
]